import { useState } from 'react'
import { Mail, X, RefreshCw } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

interface VerificationBannerProps {
  email: string
  onResend: () => Promise<void>
}

export function VerificationBanner({ email, onResend }: VerificationBannerProps) {
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  const handleResend = async () => {
    setSending(true)
    try {
      await onResend()
      setSent(true)
      setTimeout(() => setSent(false), 5000)
    } finally {
      setSending(false)
    }
  }

  return (
    <div className="bg-gold-light border-b border-gold/30 px-4 py-3">
      <div className="max-w-7xl mx-auto flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-gold/20 flex items-center justify-center flex-shrink-0">
          <Mail size={16} className="text-gold-dark" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[13px] font-medium text-ink">
            Vérifiez votre adresse email pour accéder à tous les modules
          </p>
          <p className="text-[11px] text-ink-muted mt-0.5">
            Un email a été envoyé à <strong className="text-ink">{email}</strong>
          </p>
        </div>
        <button
          onClick={handleResend}
          disabled={sending || sent}
          className={cn(
            'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[12px] font-medium transition-all',
            sent
              ? 'bg-teal-light text-teal-dark'
              : 'bg-white border border-gold/30 text-gold-dark hover:bg-gold/10',
            (sending || sent) && 'opacity-70 cursor-not-allowed',
          )}
        >
          {sending ? (
            <><RefreshCw size={12} className="animate-spin" /> Envoi…</>
          ) : sent ? (
            'Email envoyé ✓'
          ) : (
            'Renvoyer l\'email'
          )}
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 text-ink-faint hover:text-ink transition-colors"
          title="Fermer"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  )
}
